import { Result, Button } from 'antd';
import { history } from '$src/stores/history';
import useStores from '$src/hooks/useStores';
import { routes } from '$src/routes';
import { NOT_FOUND_PAGE_ID } from '$src/constants/actions';
import { useEffect } from 'react';

const NotFound = () => {
  const {
    statsStore: { sendStats },
  } = useStores();
  useEffect(() => {
    sendStats(undefined, undefined, NOT_FOUND_PAGE_ID);
  }, [sendStats]);

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button onClick={() => history.push(routes.root)} type="primary">
          Back Home
        </Button>
      }
    />
  );
};

export default NotFound;
